export const VAD_NULL_RESOURCE_DESTROY_MESSAGE =
  "MicVAD has null stream, audio context, or processor adapter";

export function isKnownUnstartedVadDestroyRejection(reason: unknown): boolean {
  return reason instanceof Error && reason.message === VAD_NULL_RESOURCE_DESTROY_MESSAGE;
}

/**
 * Keep the rejection listener dormant while the panel is mounted. Calling the
 * returned cleanup function opens only the short window in which vad-react's
 * asynchronous destroy rejection can reach the browser, then removes itself.
 */
export function guardUnstartedVadDestroyDuringUnmount(graceMs = 500): () => void {
  let cleanupDeadline = 0;
  const onUnhandledRejection = (event: PromiseRejectionEvent) => {
    if (cleanupDeadline === 0 || Date.now() > cleanupDeadline
      || !isKnownUnstartedVadDestroyRejection(event.reason)) return;
    event.preventDefault();
  };
  window.addEventListener("unhandledrejection", onUnhandledRejection);
  return () => {
    cleanupDeadline = Date.now() + graceMs;
    window.setTimeout(() => {
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    }, graceMs);
  };
}
